import { render, staticRenderFns } from "./MessageComp.vue?vue&type=template&id=14c6608c&scoped=true"
import script from "./MessageComp.vue?vue&type=script&lang=js"
export * from "./MessageComp.vue?vue&type=script&lang=js"
import style0 from "./MessageComp.vue?vue&type=style&index=0&id=14c6608c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c6608c",
  null
  
)

export default component.exports